import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getItemSalesData = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_ITEM_SALES_DATA,
    payload: paramObj,
    meta: {
        type: 'apijson',
        url: baseUrl + '/item_sales',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond,
        },
        options: {
            method: 'GET'
        }
    }
})